export const airlinesTranslations = {
  ua: {
    metaTitle: 'Платформа дистрибуції авіаконтенту | Інтеграція NDC і GDS для авіакомпаній',
    metaDescription:
      'Оптимізуйте дистрибуцію авіаконтенту за допомогою єдиної платформи, що об’єднує NDC, GDS і прямі канали. Знижуйте витрати, розширюйте можливості продажу та масштабуйте дистрибуцію авіакомпанії.',
    heroContent: {
      title: 'Для авіакомпаній',
      subtitle: 'Єдина платформа для дистрибуції, продажів і зростання.',
      description:
        'Адаптуйте офери для різних каналів, доповнюйте їх послугами та відкривайте для продажу на одній платформі. Зберігайте контроль над дистрибуцією й охоплюйте IATA-агентства, агентства без акредитації IATA, OTA та суперзастосунки.',
      ctaLabel: 'Запланувати демо',
    },
    distributionContent: {
      heading: 'Як DRCT вирішує проблеми дистрибуції авіакомпаній',
      description:
        'У GDS та непрямих каналах авіакомпаніям складно контролювати, як представлені їхні офери. DRCT об’єднує дистрибуцію та керування оферами, щоб їхній склад і умови зберігалися в кожному каналі.',
      tabOneLabel: 'Контроль дистрибуції',
      tabTwoLabel: 'Впровадження NDC',
      tabOneCards: [
        {
          title: 'Дистрибуція на одній платформі',
          description:
            'DRCT приводить офери авіакомпаній до єдиного формату та передає їх через одне підключення. Керування замовленнями, звітність і розрахунки зібрані в одному місці — працювати простіше, а дані не розпорошені між системами.',
        },
        {
          title: 'Офер зберігається на всьому шляху до продажу',
          description:
            'DRCT зберігає повний склад офера: тарифи, додаткові послуги, пакети та правила формування ціни. У кожному каналі клієнт бачить саме ту пропозицію, яку ви створили, а ви отримуєте більше доходу від додаткових послуг у кожному бронюванні.',
        },
        {
          title: 'Узгоджені ціни й точніші дані про попит',
          description:
            'DRCT допомагає контролювати, як офери надходять у канали продажу та як із ними працюють. Це дає змогу узгоджувати ціни, краще персоналізувати пропозиції й точніше оцінювати попит у всіх каналах.',
        },
      ],
      tabTwoCards: [
        {
          title: 'NDC у звичній роботі агентів',
          description:
            'DRCT додає контент NDC до інструментів, якими вже користуються агенти, зокрема до рішень для роботи з GDS. Агентам не потрібно опановувати нові системи, тож NDC впроваджується швидше й без зміни звичних процесів.',
        },
        {
          title: 'Вигідніші продажі',
          description:
            'DRCT дає змогу передавати контент напряму від авіакомпанії до продавця й поступово переводити бронювання з GDS до NDC. Менша залежність від посередників поліпшує економіку кожного продажу, а охоплення агентів зберігається.',
        },
      ],
    },
    workflowContent: {
      heading: 'Як це працює',
      description:
        'DRCT передає ваш контент продавцям авіаквитків через єдину платформу. Склад оферів зберігається, а ви контролюєте, як вони надходять до продавців і як із ними працюють.',
      sourceEyebrow: 'Контент авіакомпанії',
      sourceHeading: 'Ваші офери',
      sourceItems: ['Контент GDS', 'Офери NDC', 'Власна модель дистрибуції'],
      coreHeading: 'Оркестраційний шар',
      pipelineSteps: [
        { text: 'Отримання даних і єдиний формат' },
        { text: 'Формування й доповнення оферів' },
        { text: 'Представлення оферів і ціни' },
        { text: 'Замовлення та обслуговування' },
      ],
      coreNoteText: 'Офери, їхній склад і правила залишаються під вашим контролем.',
      destEyebrow: 'Продавці авіаквитків',
      destHeading: 'Усі канали',
      destItems: ['IATA-агентства', 'Агенти без IATA', 'OTA, TMC'],
      steps: [
        {
          heading: 'Отримання оферів',
          description:
            'DRCT отримує ваші офери та приводить їх до єдиного формату, зберігаючи всі умови й характеристики.',
        },
        {
          heading: 'Формування й доповнення оферів',
          description:
            'DRCT формує офери й доповнює їх новими можливостями. Зокрема, віртуальний інтерлайн дає змогу поєднувати рейси різних авіакомпаній у маршрути, яких немає в окремого перевізника.',
        },
        {
          heading: 'Передача оферів продавцям',
          description:
            'Офери надходять до всіх підключених продавців через DRCT Extension, Search або API. Їхній склад і умови зберігаються в кожному каналі.',
        },
        {
          heading: 'Керування замовленнями',
          description:
            'Зміни, скасування, повернення й додаткові послуги оформлюються в DRCT. Авіакомпанія бачить усі операції та зберігає контроль, а агенти можуть обслуговувати бронювання без додаткових звернень до перевізника.',
        },
      ],
    },
    whyContent: {
      heading: 'Чому авіакомпанії обирають DRCT',
      description:
        'DRCT допомагає охопити всі типи агентів і дає кожному потрібні інструменти для продажу й обслуговування контенту NDC — можливість, якої бракує більшості платформ дистрибуції.',
      items: [
        {
          title: 'Швидше впровадження NDC',
          description:
            'Агенти починають працювати з NDC через інструмент, який їм підходить. Переходити на іншу систему не потрібно.',
        },
        {
          title: 'Агенти продають самостійно',
          description:
            'Агенти шукають, порівнюють і бронюють ваш контент NDC без дзвінків до авіакомпанії — від вибору тарифу до виписки квитка.',
        },
        {
          title: 'Самостійне обслуговування бронювань',
          description:
            'Агенти самі оформлюють зміни, скасування, повернення й додаткові послуги. Без черг на ручне опрацювання та звернень до авіакомпанії.',
        },
        {
          title: 'Продаж додаткових послуг',
          description:
            'Агенти додають місця, багаж та інші послуги під час продажу. Середня вартість бронювання зростає без додаткової роботи з вашого боку.',
        },
        {
          title: 'Охоплення всіх типів агентів',
          description:
            'Працюйте з IATA-агентствами, агентствами без акредитації IATA, OTA та TMC. DRCT пропонує Extension у GDS, інтерфейс Search та API. Усі три інструменти працюють разом і відкривають доступ до NDC у звичному для агента середовищі.',
        },
        {
          title: 'Підтримка 24/7',
          description:
            'Проблеми з дистрибуцією, збої бронювання та складні випадки вирішують люди, які створили платформу.',
        },
      ],
    },
    finalCtaContent: {
      title: 'Готові оновити дистрибуцію?',
      description:
        'Обговоріть із командою DRCT, як зараз працює ваша дистрибуція та чого ви хочете досягти.',
      ctaLabel: 'Запланувати демо',
    },
    faqContent: {
      heading: 'Поширені запитання',
      description: 'Не знайшли відповіді? Зверніться до нашої служби підтримки.',
      items: [
        {
          question: 'Чи може авіакомпанія повністю замінити GDS на NDC?',
          answer:
            'Більшість авіакомпаній не можуть відмовитися від GDS одразу. Реалістичніший шлях — поступово збільшувати частку бронювань через NDC, зберігаючи охоплення агентів. Поєднання GDS і NDC допомагає підтримувати стабільну роботу та уникати перебоїв під час переходу.',
        },
        {
          question: 'Як на практиці працює поєднання GDS і NDC?',
          answer:
            'Контент GDS і NDC доступний на одній платформі. DRCT об’єднує його, щоб агенти бачили пропозиції в єдиному зведеному вигляді та простіше з ними працювали. Так контент узгоджено надходить до всіх каналів продажу.',
        },
        {
          question: 'Як перейти від GDS до NDC і зберегти охоплення агентів?',
          answer:
            'Переходьте поетапно, додаючи NDC до наявних процесів роботи з GDS. DRCT дає агентам змогу залишатися у звичному середовищі, поки авіакомпанія нарощує продажі через NDC та зберігає охоплення мережі.',
        },
        {
          question: 'Як DRCT допомагає знизити витрати на дистрибуцію?',
          answer:
            'DRCT об’єднує контент авіакомпаній і допомагає переводити бронювання з GDS до NDC та прямих каналів. Це зменшує залежність від посередників і дає змогу знижувати витрати на кожне бронювання зі зростанням частки NDC.',
        },
        {
          question: 'Як DRCT підтримує додаткові послуги, пакети й персональні пропозиції?',
          answer:
            'DRCT дає змогу формувати пакети в реальному часі, пропонувати додаткові послуги та персональні ціни. Ці офери узгоджено представлені в усіх каналах, що допомагає збільшувати частку успішних продажів і дохід із бронювання.',
        },
      ],
    },
  },
  pl: {
    metaTitle: 'Platforma dystrybucji treści lotniczych | Integracja NDC i GDS dla linii lotniczych',
    metaDescription:
      'Optymalizuj dystrybucję treści lotniczych dzięki jednej platformie łączącej NDC, GDS i kanały bezpośrednie. Obniżaj koszty, rozwijaj sprzedaż detaliczną i skaluj dystrybucję lotniczą.',
    heroContent: {
      title: 'Dla linii lotniczych',
      subtitle: 'Jedna platforma do dystrybucji, sprzedaży i rozwoju.',
      description:
        'Dostosowuj oferty do różnych kanałów, uzupełniaj je o usługi i udostępniaj do sprzedaży na jednej platformie. Zachowaj kontrolę nad dystrybucją i docieraj do biur z akredytacją IATA i bez niej, OTA oraz superaplikacji.',
      ctaLabel: 'Umów demo',
    },
    distributionContent: {
      heading: 'Jak DRCT rozwiązuje problemy dystrybucji linii lotniczych',
      description:
        'W GDS i kanałach pośrednich liniom lotniczym trudno kontrolować sposób prezentacji ofert. DRCT łączy dystrybucję z zarządzaniem ofertami, aby ich zawartość i warunki pozostały spójne w każdym kanale.',
      tabOneLabel: 'Kontrola dystrybucji',
      tabTwoLabel: 'Wdrożenie NDC',
      tabOneCards: [
        {
          title: 'Dystrybucja na jednej platformie',
          description:
            'DRCT ujednolica format ofert linii lotniczych i dostarcza je przez jedną integrację. Zamówienia, raportowanie i rozliczenia są obsługiwane w jednym miejscu. Praca jest prostsza, a dane nie są rozproszone między systemami.',
        },
        {
          title: 'Kompletna oferta aż do momentu sprzedaży',
          description:
            'DRCT zachowuje pełną zawartość oferty: taryfy, usługi dodatkowe, pakiety i zasady ustalania cen. W każdym kanale klient widzi ofertę zgodną z Twoim zamysłem, a Ty zwiększasz przychód z usług dodatkowych w każdej rezerwacji.',
        },
        {
          title: 'Spójne ceny i dokładniejsze dane o popycie',
          description:
            'DRCT pomaga kontrolować, jak oferty trafiają do kanałów sprzedaży i jak są wykorzystywane. Dzięki temu możesz utrzymywać spójne ceny, lepiej personalizować oferty i dokładniej oceniać popyt we wszystkich kanałach.',
        },
      ],
      tabTwoCards: [
        {
          title: 'NDC w codziennej pracy agentów',
          description:
            'DRCT udostępnia oferty NDC w narzędziach, z których agenci już korzystają, również w rozwiązaniach współpracujących z GDS. Agenci nie muszą uczyć się nowych systemów, więc wdrożenie NDC przebiega szybciej i bez zmiany dotychczasowych procesów.',
        },
        {
          title: 'Bardziej rentowna sprzedaż',
          description:
            'DRCT umożliwia bezpośrednią dystrybucję ofert od linii lotniczej do sprzedawcy i stopniowe przenoszenie rezerwacji z GDS do NDC. Mniejsza zależność od pośredników poprawia rentowność sprzedaży przy zachowaniu zasięgu sieci agentów.',
        },
      ],
    },
    workflowContent: {
      heading: 'Jak to działa',
      description:
        'DRCT dostarcza Twoje oferty sprzedawcom biletów przez jedną platformę. Zawartość ofert pozostaje niezmieniona, a Ty kontrolujesz sposób ich dystrybucji i obsługi.',
      sourceEyebrow: 'Oferta linii lotniczej',
      sourceHeading: 'Twoje oferty',
      sourceItems: ['Oferty GDS', 'Oferty NDC', 'Własny model dystrybucji'],
      coreHeading: 'Warstwa orkiestracji',
      pipelineSteps: [
        { text: 'Pobieranie i ujednolicanie danych' },
        { text: 'Tworzenie i uzupełnianie ofert' },
        { text: 'Prezentacja ofert i ceny' },
        { text: 'Zamówienia i obsługa' },
      ],
      coreNoteText: 'Oferty, ich zawartość i zasady pozostają pod Twoją kontrolą.',
      destEyebrow: 'Sprzedawcy biletów',
      destHeading: 'Wszystkie kanały',
      destItems: ['Biura z IATA', 'Agenci bez IATA', 'OTA, TMC'],
      steps: [
        {
          heading: 'Pobieranie ofert',
          description:
            'DRCT pobiera Twoje oferty i ujednolica ich format, zachowując wszystkie warunki i szczegóły.',
        },
        {
          heading: 'Tworzenie i uzupełnianie ofert',
          description:
            'DRCT tworzy oferty i rozszerza ich możliwości. Wirtualny interlining pozwala na przykład łączyć loty różnych linii w trasy, których nie oferuje pojedynczy przewoźnik.',
        },
        {
          heading: 'Dostarczanie ofert sprzedawcom',
          description:
            'Oferty trafiają do wszystkich podłączonych sprzedawców przez DRCT Extension, Search lub API. Ich zawartość i warunki pozostają spójne w każdym kanale.',
        },
        {
          heading: 'Zarządzanie zamówieniami',
          description:
            'Zmiany, anulowania, zwroty i usługi dodatkowe są obsługiwane w DRCT. Linia lotnicza widzi wszystkie operacje i zachowuje kontrolę, a agenci obsługują rezerwacje bez dodatkowego kontaktu z przewoźnikiem.',
        },
      ],
    },
    whyContent: {
      heading: 'Dlaczego linie lotnicze wybierają DRCT',
      description:
        'DRCT pozwala dotrzeć do każdego typu agenta i daje mu narzędzia potrzebne do sprzedaży i obsługi ofert NDC. To możliwość, której brakuje większości platform dystrybucji.',
      items: [
        {
          title: 'Szybsze wdrożenie NDC',
          description:
            'Agenci zaczynają korzystać z NDC w narzędziu dopasowanym do swojej pracy. Nie muszą przechodzić na inny system.',
        },
        {
          title: 'Samodzielna sprzedaż',
          description:
            'Agenci wyszukują, porównują i rezerwują Twoje oferty NDC bez telefonów do linii lotniczej — od wyboru taryfy po wystawienie biletu.',
        },
        {
          title: 'Samodzielna obsługa rezerwacji',
          description:
            'Agenci sami wprowadzają zmiany, anulują rezerwacje, realizują zwroty i dodają usługi. Bez kolejek do ręcznej obsługi i kontaktu z linią lotniczą.',
        },
        {
          title: 'Sprzedaż usług dodatkowych',
          description:
            'Agenci dodają miejsca, bagaż i inne usługi podczas sprzedaży. Średnia wartość rezerwacji rośnie bez dodatkowej pracy po Twojej stronie.',
        },
        {
          title: 'Dotarcie do każdego typu agenta',
          description:
            'Współpracuj z biurami z akredytacją IATA i bez niej, OTA oraz TMC. DRCT oferuje Extension w GDS, interfejs Search i API. Wszystkie trzy narzędzia współpracują ze sobą i udostępniają NDC w środowisku, które agent już zna.',
        },
        {
          title: 'Wsparcie 24/7',
          description:
            'Problemy z dystrybucją, błędy rezerwacji i trudne przypadki rozwiązują ludzie, którzy stworzyli platformę.',
        },
      ],
    },
    finalCtaContent: {
      title: 'Czas unowocześnić dystrybucję?',
      description:
        'Porozmawiaj z zespołem DRCT o tym, jak działa dziś Twoja dystrybucja i co chcesz osiągnąć.',
      ctaLabel: 'Umów demo',
    },
    faqContent: {
      heading: 'Najczęstsze pytania',
      description: 'Nie widzisz odpowiedzi? Skontaktuj się z naszym zespołem wsparcia.',
      items: [
        {
          question: 'Czy linia lotnicza może całkowicie przejść z GDS na NDC?',
          answer:
            'Większość linii lotniczych nie może od razu zrezygnować z GDS. Bardziej realne jest stopniowe zwiększanie udziału rezerwacji NDC przy zachowaniu zasięgu sieci agentów. Łączenie GDS i NDC pomaga utrzymać stabilną pracę i uniknąć zakłóceń podczas przejścia.',
        },
        {
          question: 'Jak w praktyce działa połączenie GDS i NDC?',
          answer:
            'Oferty GDS i NDC są dostępne na jednej platformie. DRCT łączy je w jednym przejrzystym widoku, ułatwiając agentom codzienną pracę. Dzięki temu oferty trafiają do wszystkich kanałów sprzedaży w spójnej formie.',
        },
        {
          question: 'Jak przejść z GDS do NDC bez utraty zasięgu wśród agentów?',
          answer:
            'Wprowadzaj NDC etapami do dotychczasowych procesów pracy z GDS. Dzięki DRCT agenci pozostają w znanym środowisku, a linia lotnicza rozwija sprzedaż NDC bez ograniczania zasięgu swojej sieci.',
        },
        {
          question: 'Jak DRCT pomaga obniżyć koszty dystrybucji?',
          answer:
            'DRCT agreguje oferty linii lotniczych i pomaga przenosić rezerwacje z GDS do NDC oraz kanałów bezpośrednich. Zmniejsza to zależność od pośredników i pozwala obniżać koszt pojedynczej rezerwacji wraz ze wzrostem udziału NDC.',
        },
        {
          question: 'Jak DRCT wspiera usługi dodatkowe, pakiety i oferty personalizowane?',
          answer:
            'DRCT umożliwia tworzenie pakietów w czasie rzeczywistym, sprzedaż usług dodatkowych i oferowanie spersonalizowanych cen. Oferty są spójnie prezentowane we wszystkich kanałach, co pomaga zwiększać konwersję i przychód z każdej rezerwacji.',
        },
      ],
    },
  },
};
